import { connect } from 'react-redux'

import { toggleSidebar } from '../../../../common/actions/layout'
import ToggleButton from './toggleButton'

const mapStateToProps = (state, ownProps) => {
  const { layout: { isSidebarOpen } } = state

  return { expanded: isSidebarOpen }
}

const mapDispatchToProps = dispatch => {
  return {
    toggleSidebar: () => {
      dispatch(toggleSidebar())
    }
  }
}

const ToggleButtonContainer = connect(mapStateToProps, mapDispatchToProps)(
  ToggleButton
)

export default ToggleButtonContainer
